import React from 'react';
import { IIcons } from '../interfaces/icons';
import { getColorHelper } from '../utils/getColorHelpers';

export function Close({
  fillColor = '#071C3E',
  colorWeight,
  isActive,
  size = 16,
  height,
  width,
  onClick,
}: IIcons) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={size || height}
      width={size || width}
      fill="none"
      onClick={onClick}
      viewBox="0 0 12 12"
      style={{ cursor: isActive ? 'pointer' : 'default' }}
    >
      <path
        stroke={getColorHelper(fillColor, colorWeight)}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m.75.75 10.5 10.5M11.25.75.75 11.25"
      />
    </svg>
  );
}
